import { Helpers } from '../../helpers';
import { IScenarioStatus } from '../../interfaces/iscenario-status';
import { Scenario } from '../scenario';

export class ScenarioStatusBase {
  ScenarioStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Scenarios_ScenarioStatus?: Array<Scenario> | null;

  constructor(item?: IScenarioStatus) {
    if (item) {

      this.ScenarioStatusId = item.ScenarioStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Scenarios_ScenarioStatus = Helpers.createClassArray(Scenario, item.Scenarios_ScenarioStatus);
    }
  }
}